import axios from 'axios';

const API_URL = 'https://backend.controlease.com.br/api/users/';

class UserService {
  async updateUser(userId, userData) {
    try {
      const url = `${API_URL}register/address/${userId}`;
      const response = await axios.put(url, userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao atualizar usuário.',
      };
    }
  }
}

export default new UserService();